import ThiSensorProfile from "./thi-sensor-profile.vue";

export default ThiSensorProfile;



// WEBPACK FOOTER //
// ./src/components/_thi-sensor-profile/index.js